import Model from '@/Models/Model'

export default class Company extends Model {
  /**
   * Resource
   *
   * @returns {string}
   */
  resource() {
    return 'company-management'
  }
}
